import { ViewportScroller } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  user;
  extra = true;
     constructor(private router: Router, private http: HttpClient, private viewportScroller: ViewportScroller) { }
 

  ngOnInit(): void {
       this.user = JSON.parse(localStorage.getItem('clpUser'));
    if (localStorage.getItem("clpUser") != null) {
      this.extra = false;

    }  }
  logout() {

    // this.router.navigate(['/account/login']);
    localStorage.clear();
  //     localStorage.removeItem("clpUser");
  // localStorage.removeItem("token");
  // localStorage.removeItem("gdpr_seen_banner");

     this.router.navigate(['/account/login']).then(() => {
    window.location.reload();
  });
  }
  dashboard() {
    this.user = JSON.parse(localStorage.getItem('clpUser')).type
    if (this.user == 1) {
      this.router.navigate(['/buyer/marketplace']);
    } else {
      this.router.navigate(['/seller/contentlist']);
    }

  }
  gotoScroll(itemId:string){
    this.viewportScroller.scrollToAnchor(itemId);
  }
}
